<template>
  <router-link tag="div" :to="{name:'subject',params: {slug: subject.slug}}"
               class="card shadow rounded-10 border-0 mcheight">
    <div class="card-header fz-22 bg-extra d-flex align-items-center mh60x p-2 text-wrap">
      <img :src="subject.logo" alt="" class="wh42x mr-3 rounded">
      <div class="name">{{subject.name}}</div>
    </div>
    <div class="card-body">
      <div class="d-flex justify-content-between fz-8">
        <div>
          <div>
            <img src="@img/network.svg" alt="" class="wh20x">
            {{subject.stats.chapter}}
          </div>
          <span>Chapitres</span>
        </div>
        <div>
          <div>
            <img src="@img/tick.svg" alt="" class="wh20x">
            {{subject.stats.correct}}
          </div>
          <span>Correctes</span>
        </div>
        <div>
          <div>
            <img src="@img/no.svg" alt="" class="wh20x">
            {{subject.stats.failed}}
          </div>
          <span>Echouées</span>
        </div>
        <div>
          <div>
            <img src="@img/form-line.svg" alt="" class="wh20x">
            {{subject.stats.lesson}}
          </div>
          <span>Leçon</span>
        </div>
      </div>
      <div class="d-flex mt-3 fz-10">
        <button v-if="subject.started" class="btn-outline-primary py-2 px-2 rounded-5 border-1x mr-3">Continuer</button>
        <button v-else class="card-course-btn text-white py-2 px-2 rounded-5 border-0 bg-extra">Commencer</button>
      </div>
    </div>
  </router-link>
</template>

<script>
  export default {
    name: 'Subject',
    props: {subject: {type: Object}}
  }
</script>

<style lang="scss">

  .card-header .name {
    @include no-break();
  }
</style>
